import type { AnalyticsClient } from "./analyticsClient";

/**
 * Analytics client that drops everything.
 *
 * The default in tests, in Storybook, in local development, and wherever
 * consent has been declined or no Freshpaint key is configured — so call sites
 * never have to null-check the client.
 */
export const createNoopAnalyticsClient = (): AnalyticsClient => ({
  track: () => undefined,
  identify: () => undefined,
  reset: () => undefined,
});
